import validate from 'validate.js';
import validators from '../common/validators';

export const bootstrapValidators = () => {
    validate.validators = {
        ...validate.validators,
        ...validators
    };
};
